import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = false;

export let state = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
